import { localePromocodeType } from '../en-US'

export const promocode: localePromocodeType = {
  inputPromocode: 'Por favor, ingrese un código promocional',
  promocode: 'Código promocional',
  activate: 'Activar',
  promocodes: 'Códigos promocionales',
  success: 'Has activado correctamente el código promocional',
  notFinded: 'no encontrado',
  backToProfile: 'Volver al perfil',
  noSuch: 'No existe tal código promocional',
  info: 'Información',
  activatePromocode: 'Activar código promocional',
  id: 'ID',
  site: 'Sitio web',
  description: 'Descripción',
  code: 'Código',
  generatePromo: 'Generar código promocional',
  promocodeValid: 'El código promocional es válido',
}
